/* Keep the native Shopify form and RD automatic conversion together. */
(function () {
  'use strict';
  const mappings = [
    ['cf_produto', '.halo-notify-product-title'],
    ['cf_variacao_do_produto_me_avise', '.halo-notify-product-variant'],
    ['cf_link_do_produto_me_avise', '.halo-notify-product-link']
  ];
  function sync(form) {
    mappings.forEach(function (mapping) {
      const source = form.querySelector(mapping[1]);
      if (!source) return;
      let input = form.querySelector('input[name="' + mapping[0] + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = mapping[0];
        form.appendChild(input);
      }
      let value = source.value.trim();
      if (mapping[0] === 'cf_link_do_produto_me_avise' && value) {
        try {
          if (!/^(https?:\/\/|\/)/i.test(value)) value = 'https://' + value;
          value = new URL(value, window.location.origin).href;
        } catch (_) { value = ''; }
      }
      input.value = value;
    });
  }
  function addPhone(form) {
    if (form.querySelector('[data-notify-phone]')) return;
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    const field = document.createElement('div');
    field.className = 'asos-notify-phone-field';
    const label = document.createElement('label');
    const phone = document.createElement('input');
    phone.id = (form.id || 'notifyMe') + '-mobile';
    phone.type = 'tel';
    phone.name = 'contact[phone]';
    phone.className = 'form-input';
    phone.autocomplete = 'tel';
    phone.inputMode = 'tel';
    phone.placeholder = '(31) 99999 9999';
    phone.maxLength = 20;
    phone.setAttribute('data-notify-phone', '');
    label.className = 'form-label';
    label.htmlFor = phone.id;
    label.textContent = 'Celular com DDD (opcional)';
    function validate() {
      let digits = phone.value.replace(/\D/g, '');
      if (digits.length === 13 && digits.indexOf('55') === 0) digits = digits.slice(2);
      phone.setCustomValidity(!phone.value.trim() || /^[1-9][0-9]9[0-9]{8}$/.test(digits)
        ? '' : 'Informe um celular com DDD e 9 dígitos.');
      const rd = form.querySelector('[name="mobile_phone"]');
      if (rd) {
        rd.value = digits ? '+55' + digits : '';
        rd.disabled = !digits;
      }
    }
    const rd = document.createElement('input');
    rd.type = 'hidden';
    rd.name = 'mobile_phone';
    rd.disabled = true;
    form.appendChild(rd);
    phone.addEventListener('input', validate);
    phone.addEventListener('change', validate);
    field.appendChild(label);
    field.appendChild(phone);
    button.before(field);
    form.classList.add('asos-notify-with-phone');
  }
  function init(root) {
    root.querySelectorAll('form.notifyMe-form').forEach(function (form) {
      addPhone(form);
      sync(form);
    });
  }
  init(document);
  // Document capture runs before RD's capture listener on the submit button.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('button[type="submit"], input[type="submit"]');
    const form = button && button.form;
    if (form && form.matches('.notifyMe-form')) sync(form);
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form.notifyMe-form')) sync(event.target);
  }, true);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
